import Vue from 'vue'
import vuetify from './vuetify'
import './veeValidate'
import App from './App.vue'

import 'flag-icons/css/flag-icons.min.css';
import 'v-phone-input/dist/v-phone-input.css';
import { createVPhoneInput } from 'v-phone-input';

const vPhoneInput = createVPhoneInput({
  countryIconMode: 'svg'
});

Vue.use(vPhoneInput);

//Aplify Auth
import './amplify'
import Auth from '@/helpers/Auth'

window.LOG_LEVEL = 'DEBUG'

Vue.config.productionTip = false

Vue.prototype.$searchParams = window

const navigateToAdmin = (query) => {
	if (query) {
		location.replace(
			location.protocol + "//" + process.env.VUE_APP_user_domain + '?orgID=' + query
		);
	} else {
		location.replace(
			location.protocol + "//" + process.env.VUE_APP_admin_domain
		);
	}
	
}

const  navigateToCustomer = () => {
	location.replace(
		location.protocol + "//" + process.env.VUE_APP_user_domain
	);
}

const goDriveRedirect = () => {
	location.replace(
		location.protocol + "//" + process.env.VUE_APP_go_portal_redirect + '/landing/Dashboard'
	);
}

const navigateToZero = () => {
	location.replace(
		location.protocol + "//" + process.env.VUE_APP_zero_domain
	)
}

const handleNavigation = (user, queryStr) => {
	try {
		const availableServices = user["custom:services"]
		const servicesList = availableServices.split(/\s*,\s*/)
		if(servicesList.includes('cameramatics')) {
			if (user["custom:role"].toLowerCase() == 'sys_admin' || user["custom:role"].toLowerCase() == 'support_admin' || user["custom:role"].toLowerCase() == 'support_lead' || user["custom:role"].toLowerCase() == 'firmware_manager') {
				navigateToAdmin(queryStr);
			} else {
				navigateToCustomer();
			}
		}
		else if(servicesList.includes('safetyCentre')) {
			goDriveRedirect()
		}
		else if(servicesList.length == 1 && servicesList[0] == 'zero') {
			navigateToZero()
		}
	}

	catch {
		return false
	}
}

Auth.currentSession().then((res) => {
	handleNavigation(res.User)
}).catch(() => {
	new Vue({
		vuetify,
		render: h => h(App)
	}).$mount('#app')
})
